import { createCollaboratorLink, listCollaboratorLinks, revokeCollaboratorLink } from '@/api/generated/sdk.gen';
import type { CollaboratorLinkDto } from '@/api/generated/types.gen';
import { handleResponse } from '@/core/api/response-handler';

export type { CollaboratorLinkDto };

/**
 * Linkurile de colaborator ale unei scoli. Autorizarea (PROFESOR - doar scoala pe care o
 * coordoneaza, ADMIN/DBEST - orice scoala) se verifica in backend, nu aici.
 */
class CollaboratorLinksAPI {
    async list(schoolId: string): Promise<CollaboratorLinkDto[]> {
        return handleResponse(await listCollaboratorLinks({ path: { schoolId } }));
    }
    async create(schoolId: string, label: string): Promise<CollaboratorLinkDto> {
        return handleResponse(await createCollaboratorLink({ path: { schoolId }, body: { label } }));
    }
    async revoke(schoolId: string, linkId: string): Promise<void> {
        // handleResponse arunca pe eroare (403/404/500) - fara el, clientul generat (ThrowOnError
        // = false) intoarce eroarea in loc s-o arunce, si mutatia de mai sus ar raporta "succes"
        // pentru o revocare care n-a avut loc.
        handleResponse(await revokeCollaboratorLink({ path: { schoolId, linkId } }));
    }
}

export const collaboratorLinksApi = new CollaboratorLinksAPI();
